<template>
  <div class="mb-6">
    <v-checkbox
      class="ml-3 mt-0"
      v-model="enabledSublayer"
      color="secondary lighten-1"
      hide-details
      dark
      @change="changeEnabledGrouplayer"
    >
      <template v-slot:label>
        <strong class="white--text layer-title">{{ group.name }}</strong>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: "LeftSatelliteSublayer",
  props: ["group", "initialOpacity", "timeFeatures", "locations", "satellites"],
  data: () => ({
    enabledSublayer: false,
    radioGroup: undefined,
    currentState: undefined,
  }),
  created() {
    if (this.enabledSublayer) {
      this.initialize();
    }
  },
  watch: {
    enabledSublayer(value) {
      if (value) {
        this.initialize();
      }
    },
  },
  computed: {
    listTimeFeatures() {
      return this.timeFeatures?.map((timeFeature) => ({
        title: timeFeature.title,
        value: timeFeature.value, //moment(timeFeature.value).format('YYYY-MM-DD')
      }));
    },
  },
  methods: {
    initialize() {
      this.radioGroup = 0;
      if (this.locations && this.satellites) {
        this.emitCurrentState({
          location: this.locations[0],
          satellite: this.satellites[0],
        });
      }
    },
    changeEnabledGrouplayer(visible) {
      this.$emit("changeInputMenu", {
        eventName: "changeEnabledGroupLayer",
        params: { visible, name: this.group.name },
      });
    },
    changeOpacitySublayer(opacity) {
      if (this.currentState) {
        this.currentState.opacity = opacity;
        this.emitCurrentState();
      }
    },
    changeTimeFeature(timeFeature) {
      if (this.currentState) {
        this.currentState.timeFeature = timeFeature;
        this.emitCurrentState();
      }
    },
    changeSatelliteType(satellite) {
      if (this.currentState) {
        this.currentState.satellite = satellite;
        this.emitCurrentState();
      }
    },
    emitCurrentState(state) {
      if (state && state.satellite) {
        this.currentState = { ...state };
        this.currentState.satellite = state.satellite.name
          ? state.satellite.name
          : state.satellite;
      }
      this.$emit("changeCurrentSatelliteState", { ...this.currentState });
    },
  },
};
</script>
